import { DocumentNode } from 'graphql'
import api from 'src/assets/api/gql'
import { Unsub } from 'villus/dist/types/src/types.d'

export default class Subscription {
  query!: DocumentNode
  variables!: Json
  subscription!:  Unsub
  topic!: string

  constructor (query: DocumentNode, variables?: Json) {
    this.variables = variables || {}
    this.query = query
    // @ts-ignore
    this.topic = `${this.query.definitions[0].name.value} [${Object.entries(this.variables).join(',')}]`
  }

  start (listen: (payload: any) => void) {
    console.log('SUBSCRIPTION START: ' + this.topic)
    const observable = api.subscribe({
      query: this.query,
      variables: this.variables
    })
    this.subscription = observable.subscribe({
      next: (response) => {
        console.log('SUBSCRIPTION RESPONSE: ' + this.topic)
        if (response) {
          if (response.error) {
            console.error(response.error)
            throw response.error
          }
          listen( response.data )
        } else {
          console.error('SUBSCRIPTION NO RESPONSE: ' + this.topic)
          throw new Error()
        }
      },
      // eslint-disable-next-line
      error: (err) => {
        console.error('SUBSCRIPTION ERROR: ' + this.topic)
        throw new Error(err)
      },
      complete: () => {
        console.error('SUBSCRIPTION COMPLETE: ' + this.topic)
        throw new Error()
      }
    })
  }

  end () {
    console.log('SUBSCRIPTION END: ' + this.topic)
    this.subscription.unsubscribe()
  }
}
